import * as moment from 'moment/moment';

export default class ChequeBook {
  constructor() {
    this.explanation = '';

    this.type = null;
    this.ledger_type_id = null;

    this.amount = 0;
  }
}
